import { Queue } from '../../utils';

export const RecordsQueue = (() => {
  const queue = Queue({});

  return queue;
})();
